module.exports = __webpack_public_path__ + "files/ecdce8f53cb3e9efd3ecdbf848927190.png";